import angular from 'angular';
import { react2angular } from 'react2angular'
import ModalRoot from './containers/ModalRoot'
import ContextMenuRoot from './containers/ContextMenuRoot'
import DownloadHelper from './containers/DownloadHelper';
import Portal from './containers/Portal';
import Logout from './containers/Logout';
import Sidebar from './components/Sidebar';
import MenuBar from './components/MenuBar';
import UserButton from './components/UserButton';
import QuickSearchBox from './components/QuickSearchBox';
import { Icon } from 'dlweb-components';
import Breadcrumb from './components/Breadcrumb';
import DetailsPane from './components/DetailsPane';
import MultifactorVerification from './components/MultifactorVerification';

require('./containers/ModalRoot');
require('./containers/ContextMenuRoot');
require('./containers/DownloadHelper');
require('./containers/Portal');
require('./containers/Logout');
require('./containers/Layout');
require('./components/Sidebar');
require('./components/MenuBar');
require('./components/UserButton');
require('./components/QuickSearchBox');
require('./components/Breadcrumb');
require('./components/MultifactorVerification');

angular.module('webTools').component('breadcrumb', react2angular(Breadcrumb, ['paths']));
angular.module('webTools').component('detailsPane', react2angular(DetailsPane, ['store', 'dlObject'], ['$rootScope', 'File']));
angular.module('webTools').component('modalRoot', react2angular(ModalRoot, ['store'], ['$rootScope']));
angular.module('webTools').component('downloadHelper', react2angular(DownloadHelper, ['store']));
angular.module('webTools').component('sidebar', react2angular(Sidebar, ['store'], ['$rootScope', '$location', '$routeParams']));
angular.module('webTools').component('portal', react2angular(Portal, ['store']));
angular.module('webTools').component('logout', react2angular(Logout, ['store'], ['$location', '$rootScope']));
angular.module('webTools').component('menuBar', react2angular(MenuBar, ['store', 'menuItems'], ['$rootScope']));
angular.module('webTools').component('userButton', react2angular(UserButton, ['store'], ['$rootScope', '$location']));
angular.module('webTools').component('contextMenuRoot', react2angular(ContextMenuRoot, ['store'], ['$rootScope']));
angular.module('webTools').component('quickSearchBox', react2angular(QuickSearchBox, ['store'], ['$rootScope', '$location']));
angular.module('webTools').component('icon', react2angular(Icon, ['type']));
angular.module('webTools').component('multifactorVerification', react2angular(MultifactorVerification, [], ['$rootScope', '$location']));
